import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Saved from "./Pages/Saved";
import Themes from "./Pages/Themes";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Navigation from "./Components/Navigation";
import './Styles/darkMode.scss';
import './Styles/global.scss';
import './Styles/auth.scss'; // Add the auth styles
import { ColorProvider } from "./Components/Colorize/ColorContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext"; // Add AuthProvider
import Footer from "./Components/Footer";

import { AuthModalProvider } from './Components/Auth/AuthModalManager'; // Adjust path as needed
import AuthUserAndMembership from "./Components/Auth/AuthUserAndMembership";
import Subscriptions from "./Pages/Subscriptions";
import Loader from "./Components/ReusableComponents/Loader";
import ScrollToTop from "./Components/ScrollToTop";
import ProtectedGeneratorRoute from "./Components/ProtectedGeneratorRoute";
import Share from "./Pages/Share";

const shouldShowLoader = () => {
  const hasRedirectPath = localStorage.getItem('redirectAfterLogin') ||
    sessionStorage.getItem('redirectAfterLogin') ||
    window.redirectAfterLogin;

  const isHomepage = window.location.pathname === '/' || window.location.pathname === '';

  return isHomepage && hasRedirectPath;
};

// If we should show loader, add a style to hide the body initially
if (shouldShowLoader()) {
  document.body.style.visibility = 'hidden';

  // Show body again once React has rendered (with a small delay)
  setTimeout(() => {
    document.body.style.visibility = 'visible';
  }, 100);
}



const AppContent = () => {
  const { loading, user } = useAuth();


  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  const isOAuthCallback = () => {
    const hasRedirectPath = localStorage.getItem('redirectAfterLogin') ||
      sessionStorage.getItem('redirectAfterLogin') ||
      window.redirectAfterLogin;

    const isHomepage = window.location.pathname === '/' || window.location.pathname === '';

    // Only show loader if:
    // 1. We're on homepage with redirect path AND
    // 2. Auth is still loading (fresh OAuth in progress)
    // 3. NOT if user is already authenticated (stale redirect path)
    return isHomepage && hasRedirectPath && loading && !user;
  };

  const shouldShowLoading = loading || isOAuthCallback();

  // Add loading screen check
  if (shouldShowLoading) {
    return (
      <div>
        <Loader />
      </div>

    );
  }


  return (
    <AuthProvider>
      <AuthModalProvider>
        <ColorProvider>
          <div className="App">
              <Router>
                <>
                  <ScrollToTop/>
                  <div className={`page ${darkMode ? "dark" : "light"}`}>

                    {/* Navigation Bar */}
                    <Navigation darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

                    {/* Routes */}
                    <Routes>
                      {/* Force users to /generator page*/}
                      <Route path="/" element={<Navigate to="/generator" replace />} />

                      <Route path="/generator" element={<ProtectedGeneratorRoute darkMode={darkMode} />} />
                      <Route path="/generator/:colorParams" element={<ProtectedGeneratorRoute darkMode={darkMode} />} />


                      <Route path="/saved" element={<Saved darkMode={darkMode} />} />
                      <Route path="/themes" element={<Themes darkMode={darkMode} />} />
                      <Route path="/privacy-policy" element={<PrivacyPolicy darkMode={darkMode} />} />
                      <Route path="/subscriptions" element={<Subscriptions darkMode={darkMode} />} />
                      <Route path="/share/*" element={<Share darkMode={darkMode} />} />

                      {/* Catch-all route for unrecognized URLs */}
                      <Route path="*" element={<Navigate to="/generator" replace />} />
                    </Routes>
                    <Footer />
                  </div>
                </>
              </Router>
            <AuthUserAndMembership />
          </div>
        </ColorProvider>
      </AuthModalProvider>
    </AuthProvider>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;





// subscription classname:
// verify-subscription

// all buttons with pri-btn, sec-btn, ter-btn, qua-btn are stored inside global.scss
// but: for export and contrast grid you customized those, so if you change any of those btn styles, change it also there



// change for both duo and  trio
// showTrio ? e00 : (showDuo ? d00 : c00) 

// show only when there is duo
// showDuo ? d00 : c00

// show only when there is trio
// showTrio ? e00 : c00

// PopupTimed:
// Save individual scale
// Save multiple scales

// PopupBackground
// export
// contrast grid
// delete color confirmation
